import React from "react";
import HAvatar from "./HAvatar";

const HMemberCard = ({ avatar, name, organization }) => {
  return (
    <div className="flex flex-col items-center">
      <HAvatar src={avatar} alt={name} className="h-16 w-16" />
      <h4 className="mt-2 text-sm font-medium">{name}</h4>
      <p className="text-xs text-gray-500">{organization}</p>
    </div>
  );
};

export default HMemberCard;
